(function () {
  var form = document.querySelector('[data-predictive-search]');
  if (!form) return;
  var input = form.querySelector('[data-predictive-search-input]');
  var results = form.querySelector('[data-predictive-search-results]');
  var historyWrap = form.querySelector('[data-search-history-wrap]');
  var historyNode = form.querySelector('[data-search-history]');
  var timer;
  var historyKey = 'fabrecia:search-history';

  function readHistory() {
    try { return JSON.parse(localStorage.getItem(historyKey) || '[]'); } catch (e) { return []; }
  }

  function renderHistory() {
    var items = readHistory();
    if (!items.length || !historyWrap || !historyNode) return;
    historyWrap.hidden = false;
    historyNode.innerHTML = items.map(function (term) { return '<a href="/search?q=' + encodeURIComponent(term) + '">' + escapeHtml(term) + '</a>'; }).join('');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function saveTerm(term) {
    var items = readHistory().filter(function (item) { return item.toLowerCase() !== term.toLowerCase(); });
    items.unshift(term);
    try { localStorage.setItem(historyKey, JSON.stringify(items.slice(0, 6))); } catch (e) {}
  }

  function render(data) {
    var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
    var collections = data.resources && data.resources.results && data.resources.results.collections ? data.resources.results.collections : [];
    if (!products.length && !collections.length) {
      results.innerHTML = '<div class="empty-state"><p>No styles found. Try another search.</p></div>';
      return;
    }
    var html = products.map(function (product) {
      var img = product.image ? '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span></span>';
      return '<a class="predictive-result" href="' + product.url + '">' + img + '<span><strong>' + escapeHtml(product.title) + '</strong><span>' + (product.price || '') + '</span></span><span>View</span></a>';
    }).join('');
    html += collections.map(function (collection) {
      return '<a class="predictive-result" href="' + collection.url + '"><span></span><span><strong>' + escapeHtml(collection.title) + '</strong><span>Collection</span></span><span>View</span></a>';
    }).join('');
    results.innerHTML = html;
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    window.clearTimeout(timer);
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    timer = window.setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=6', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(render)
        .catch(function () { results.innerHTML = '<p>Search is unavailable right now.</p>'; });
    }, 180);
  });

  form.addEventListener('submit', function () {
    var query = input.value.trim();
    if (query) saveTerm(query);
  });

  renderHistory();
})();
